import { render, staticRenderFns } from "./SearchNavItemProject.vue?vue&type=template&id=4cb50b12&scoped=true"
import script from "./SearchNavItemProject.vue?vue&type=script&lang=js"
export * from "./SearchNavItemProject.vue?vue&type=script&lang=js"
import style0 from "./SearchNavItemProject.vue?vue&type=style&index=0&id=4cb50b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb50b12",
  null
  
)

export default component.exports